'use client';

import React from 'react';
import { PulseButton } from 'src/components/PulseUI/PulseButton';
import { Dialog } from 'src/components/PulseUI/Dialog';

export interface RestartRouteDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const RestartRouteDialog: React.FC<RestartRouteDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    isOpen={isOpen}
    onClose={onCancel}
    aria-labelledby="restart-route-dialog-title"
    data-testid="restart-route-dialog"
  >
    <Dialog.Header>
      <h2 className="text-lg font-medium" id="restart-route-dialog-title">
        Restart Route
      </h2>
    </Dialog.Header>
    <Dialog.Content>
      <p className="text-sm text-neutral-700 p-4">
        This will clear all visit history for this route. The route and its
        stops will be kept.
      </p>
    </Dialog.Content>
    <Dialog.Actions>
      <PulseButton
        variant="outline"
        onClick={onCancel}
        className="w-full rounded-full"
        data-testid="restart-route-dialog-cancel"
      >
        Cancel
      </PulseButton>
      <PulseButton
        variant="solid"
        color="danger"
        onClick={onConfirm}
        className="w-full rounded-full"
        data-testid="restart-route-dialog-confirm"
      >
        Restart
      </PulseButton>
    </Dialog.Actions>
  </Dialog>
);

export default RestartRouteDialog;
